import React from "react";
import Input from "components/elements/Input/Input";
import Select from "components/elements/Input/Select";
import DynamicFontAwesomeIcon from "components/elements/DynamicFontAwesomeIcon";

/**
 * Component for collecting customer information during checkout
 */
const CustomerForm = ({ formData, formErrors, onChange }) => {
	return (
		<>
			<h3 className="fs-5 mb-3">Persönliche Informationen</h3>
			<div className="row mb-3">
				<div className="col-md-4">
					<Select
						id="formOfAddress"
						name="formOfAddress"
						label="Anrede"
						value={formData.formOfAddress}
						onChange={onChange}
						options={[
							{ value: "Herr", label: "Herr" },
							{ value: "Frau", label: "Frau" },
							{ value: "Divers", label: "Divers" }
						]}
						aria-label="Anrede auswählen"
						data-field="formOfAddress"
					/>
				</div>
				<div className="col-md-4">
					<Input
						type="text"
						id="title"
						name="title"
						label="Akademischer Titel (optional)"
						value={formData.title}
						onChange={onChange}
						placeholder="z.B. Dr., Prof."
						aria-label="Akademischer Titel"
						data-field="title"
					/>
				</div>
			</div>
			<div className="row mb-3">
				<div className="col-md-6">
					<Input
						type="text"
						id="name"
						name="name"
						label="Vorname"
						value={formData.name}
						onChange={onChange}
						error={formErrors.name}
						required
						aria-required="true"
						aria-label="Vorname eingeben"
						data-field="name"
					/>
				</div>
				<div className="col-md-6">
					<Input
						type="text"
						id="lastName"
						name="lastName"
						label="Nachname"
						value={formData.lastName}
						onChange={onChange}
						error={formErrors.lastName}
						required
						aria-required="true"
						aria-label="Nachname eingeben"
						data-field="lastName"
					/>
				</div>
			</div>
			<div className="row mb-3">
				<div className="col-md-6">
					<Input
						type="email"
						id="email"
						name="email"
						label="E-Mail Adresse"
						value={formData.email}
						onChange={onChange}
						error={formErrors.email}
						required
						aria-required="true"
						aria-label="E-Mail Adresse eingeben"
						data-field="email"
					/>
				</div>
				<div className="col-md-6">
					<Input
						type="tel"
						id="phone"
						name="phone"
						label="Telefon (optional)"
						value={formData.phone}
						onChange={onChange}
						aria-label="Telefonnummer eingeben"
						data-field="phone"
					/>
				</div>
			</div>
			<div className="my-5">
				<div className="mb-3 form-check">
					<input
						type="checkbox"
						className="form-check-input"
						id="isCompany"
						name="isCompany"
						checked={formData.isCompany}
						onChange={onChange}
						data-field="isCompany"
					/>
					<label className="form-check-label" htmlFor="isCompany">
						<DynamicFontAwesomeIcon
							iconName="building"
							className="me-2"
							aria-hidden="true"
						/>
						Ich kaufe für ein Unternehmen ein
					</label>
				</div>
				{formData.isCompany && (
					<div className={`row g-3`}>
						<div className="col-md-8">
							<Input
								type="text"
								id="companyName"
								name="companyName"
								label="Firmenname"
								value={formData.companyName}
								onChange={onChange}
								error={formErrors.companyName}
								required={formData.isCompany}
								aria-required={formData.isCompany ? "true" : "false"}
								aria-label="Firmenname eingeben"
								data-field="companyName"
							/>
						</div>
						<div className="col-md-8">
							<Input
								type="text"
								id="companyPosition"
								name="companyPosition"
								label="Position (optional)"
								value={formData.companyPosition}
								onChange={onChange}
								placeholder="z.B. Marketing Manager"
								aria-label="Position im Unternehmen"
								data-field="companyPosition"
							/>
						</div>
						<div className="col-md-8">
							<div className="row">
								<div className="col-md-3">
									<Select
										id="vatCountry"
										name="vatCountry"
										label="Ländercode"
										floating={true}
										value={formData.vatCountry}
										onChange={onChange}
										options={[
											{ value: "DE", label: "DE" },
											{ value: "AT", label: "AT" },
											{ value: "CH", label: "CH" }
										]}
										aria-label="Ländercode für USt-ID auswählen"
										data-field="vatCountry"
									/>
								</div>
								<div className="col-md-9">
									<Input
										type="text"
										id="vatId"
										name="vatId"
										label="USt-ID"
										value={formData.vatId}
										onChange={onChange}
										error={formErrors.vatId}
										placeholder={`z.B. ${formData.vatCountry === 'DE' ? '123456789' : formData.vatCountry === 'AT' ? 'U12345678' : 'E123456789MWST'}`}
										required={formData.isCompany}
										aria-required={formData.isCompany ? "true" : "false"}
										aria-label="Umsatzsteuer-Identifikationsnummer eingeben"
										data-field="vatId"
									/>
								</div>
							</div>
						</div>
						<div className="col-md-8">
							<Input
								type="text"
								id="poNumber"
								name="poNumber"
								label="Bestellnummer (optional)"
								value={formData.poNumber}
								onChange={onChange}
								aria-label="Bestellnummer eingeben"
								data-field="poNumber"
							/>
						</div>
					</div>
				)}
			</div>
		</>
	);
};

export default CustomerForm;
